/* eslint-disable no-console */
import { Analysis } from 'common-spectrum';
export function fromSIV(content) {
    const analysis = new Analysis();
    const allLines = content.split(/[\r\n]+/);
    const sampleMeta = parseS(allLines.filter((line) => /X S_/.exec(line)));
    const instrumentMeta = parseV(allLines.filter((line) => /X V_/.exec(line)));
    const date = parseDate(allLines.filter((line) => /X d_t/.exec(line))[0]);
    const parts = content.split('WAVES\t');
    for (const part of parts) {
        const lines = part.split(/[\r\n]+/);
        const ys = lines
            .filter((line) => /^[\t 0-9.eE-]+$/.exec(line))
            .map((line) => Number(line));
        if (ys.length < 10)
            continue;
        const kind = lines[0].trim();
        const metaLines = lines
            .filter((line) => /^X /.exec(line))
            .map((line) => line.substring(2));
        const axis = parseScale(metaLines[0], ys.length);
        if (axis.x === undefined) {
            console.log('Unknown X axis:', axis.kind, axis.unit);
            continue;
        }
        if (axis.y === undefined || axis.y.unit !== 'A') {
            console.log('Unknown Y axis:', axis.kind, axis.unit);
            continue;
        }
        // const note = parseNote(metaLines[1]);
        const xs = axis.x.values;
        const data = {
            x: xs,
            y: ys,
        };
        const meta = {
            ...sampleMeta,
            date,
            experiment: kind,
            ...instrumentMeta,
        };
        analysis.pushSpectrum({
            x: {
                label: axis.x.kind,
                units: axis.x.unit,
                data: data.x || [],
            },
            y: {
                label: axis.y.kind,
                units: axis.y.unit,
                data: data.y,
            },
        }, { dataType: 'IV spectrum', title: '', meta });
    }
    return analysis;
}
function parseDate(line) {
    return line.replace('X d_t=', '').trim().replace(/"/g, '');
}
function parseScale(line, nbValues) {
    let result = {};
    const parts = line.replace(/ (?<part>[xy]) /g, ',$<part>,').split('; ');
    for (const part of parts) {
        const parsedPart = parseScalePart(part, nbValues);
        result[parsedPart.axis] = parsedPart;
    }
    return result;
}
function parseS(lines) {
    let result = {};
    for (const line of lines) {
        const key = getFieldName(line.replace(/X ._(?<var>[^=]*)=(?<val>.*)/, '$<var>').trim());
        let value = line
            .replace(/X ._(?<var>[^=]*)=(?<val>.*)/, '$<val>')
            .trim()
            .replace(/^"(?<val>.*)"$/, '$<val>');
        if (!isNaN(Number(value)))
            value = Number(value);
        result[key] = value;
    }
    return result;
}
function parseV(lines) {
    let result = {};
    for (const line of lines) {
        const key = getFieldName(line.replace(/X ._(?<var>[^=]*)=(?<val>.*)/, '$<var>').trim());
        let value = line
            .replace(/X ._(?<var>[^=]*)=(?<val>.*)/, '$<val>')
            .trim()
            .replace(/^"(?<val>.*)"$/, '$<val>');
        if (!isNaN(Number(value)))
            value = Number(value);
        result[key] = value;
    }
    return result;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function parseNote(line) {
    line = line.replace(/"/g, '').replace(/\\r/g, ';');
    const parts = line.split(/ *[;,] */);
    let result = {};
    for (const part of parts) {
        const semiColumn = part.indexOf(':');
        const key = getFieldName(part.substring(0, semiColumn));
        let value = part
            .substring(semiColumn + 1)
            .trim()
            .replace(/^"(?<val>.*)"$/, '$<val>');
        if (!isNaN(Number(value)))
            value = Number(value);
        if (!key)
            continue;
        result[key] = value;
    }
}
function parseScalePart(scale, nbValues) {
    const parts = scale.split(',');
    let result = {
        axis: parts[1],
        kind: parts[0],
        unit: parts[4].replace(/"/g, ''),
    };
    if (result.kind === 'SetScale/P') {
        let from = Number(parts[2]);
        const step = Number(parts[3]);
        const values = [];
        for (let i = 0; i < nbValues; i++) {
            values.push(from);
            from += step;
        }
        result.values = values;
    }
    return result;
}
function getFieldName(key) {
    const mapping = {
        CE: 'counterElectrodeType',
        Calibrationfile: 'calibrationFile',
        Username: 'username',
        WE: 'workingElectrodeGlass',
        cellname: 'cellname',
        electrolyte: 'electrolyteZ960',
        layer: 'semicondutorLayer',
        specification: 'remarks',
        temp: 'workingTemperature',
        type: 'typeOfCell',
        AR: 'cellActiveArea',
        IT: 'powerIn',
    };
    if (key in mapping)
        return mapping[key];
    return key;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVNJVi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mcm9tL2Zyb21TSVYudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsK0JBQStCO0FBQy9CLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUUzQyxNQUFNLFVBQVUsT0FBTyxDQUFDLE9BQWU7SUFDckMsTUFBTSxRQUFRLEdBQUcsSUFBSSxRQUFRLEVBQUUsQ0FBQztJQUVoQyxNQUFNLFFBQVEsR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQzFDLE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUN4RSxNQUFNLGNBQWMsR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDNUUsTUFBTSxJQUFJLEdBQUcsU0FBUyxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBRXpFLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLENBQUM7SUFFdkMsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLEVBQUU7UUFDeEIsTUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUNwQyxNQUFNLEVBQUUsR0FBRyxLQUFLO2FBQ2IsTUFBTSxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7YUFDOUMsR0FBRyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztRQUMvQixJQUFJLEVBQUUsQ0FBQyxNQUFNLEdBQUcsRUFBRTtZQUFFLFNBQVM7UUFFN0IsTUFBTSxJQUFJLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFDO1FBQzdCLE1BQU0sU0FBUyxHQUFHLEtBQUs7YUFDcEIsTUFBTSxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ2xDLEdBQUcsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBRXBDLE1BQU0sSUFBSSxHQUFHLFVBQVUsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBRWpELElBQUksSUFBSSxDQUFDLENBQUMsS0FBSyxTQUFTLEVBQUU7WUFDeEIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxpQkFBaUIsRUFBRSxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUNyRCxTQUFTO1NBQ1Y7UUFDRCxJQUFJLElBQUksQ0FBQyxDQUFDLEtBQUssU0FBUyxJQUFJLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxLQUFLLEdBQUcsRUFBRTtZQUMvQyxPQUFPLENBQUMsR0FBRyxDQUFDLGlCQUFpQixFQUFFLElBQUksQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ3JELFNBQVM7U0FDVjtRQUVELHdDQUF3QztRQUN4QyxNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQztRQUN6QixNQUFNLElBQUksR0FBRztZQUNYLENBQUMsRUFBRSxFQUFFO1lBQ0wsQ0FBQyxFQUFFLEVBQUU7U0FDTixDQUFDO1FBRUYsTUFBTSxJQUFJLEdBQUc7WUFDWCxHQUFHLFVBQVU7WUFDYixJQUFJO1lBQ0osVUFBVSxFQUFFLElBQUk7WUFDaEIsR0FBRyxjQUFjO1NBQ2xCLENBQUM7UUFDRixRQUFRLENBQUMsWUFBWSxDQUNuQjtZQUNFLENBQUMsRUFBRTtnQkFDRCxLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJO2dCQUNsQixLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJO2dCQUNsQixJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUMsSUFBSSxFQUFFO2FBQ25CO1lBQ0QsQ0FBQyxFQUFFO2dCQUNELEtBQUssRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUk7Z0JBQ2xCLEtBQUssRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUk7Z0JBQ2xCLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQzthQUNiO1NBQ0YsRUFDRCxFQUFFLFFBQVEsRUFBRSxhQUFhLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxJQUFJLEVBQUUsQ0FDN0MsQ0FBQztLQUNIO0lBQ0QsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQztBQUVELFNBQVMsU0FBUyxDQUFDLElBQVk7SUFDN0IsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxFQUFFLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBQzdELENBQUM7QUFFRCxTQUFTLFVBQVUsQ0FBQyxJQUFZLEVBQUUsUUFBZ0I7SUFDaEQsSUFBSSxNQUFNLEdBQTZCLEVBQUUsQ0FBQztJQUMxQyxNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLGtCQUFrQixFQUFFLFdBQVcsQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUV4RSxLQUFLLE1BQU0sSUFBSSxJQUFJLEtBQUssRUFBRTtRQUN4QixNQUFNLFVBQVUsR0FBRyxjQUFjLENBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBQ2xELE1BQU0sQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLEdBQUcsVUFBVSxDQUFDO0tBQ3RDO0lBQ0QsT0FBTyxNQUFNLENBQUM7QUFDaEIsQ0FBQztBQUVELFNBQVMsTUFBTSxDQUFDLEtBQWU7SUFDN0IsSUFBSSxNQUFNLEdBQW9DLEVBQUUsQ0FBQztJQUNqRCxLQUFLLE1BQU0sSUFBSSxJQUFJLEtBQUssRUFBRTtRQUN4QixNQUFNLEdBQUcsR0FBRyxZQUFZLENBQ3RCLElBQUksQ0FBQyxPQUFPLENBQUMsOEJBQThCLEVBQUUsUUFBUSxDQUFDLENBQUMsSUFBSSxFQUFFLENBQzlELENBQUM7UUFDRixJQUFJLEtBQUssR0FBb0IsSUFBSTthQUM5QixPQUFPLENBQUMsOEJBQThCLEVBQUUsUUFBUSxDQUFDO2FBQ2pELElBQUksRUFBRTthQUNOLE9BQU8sQ0FBQyxnQkFBZ0IsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUN2QyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztZQUFFLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDakQsTUFBTSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEtBQUssQ0FBQztLQUNyQjtJQUNELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUM7QUFFRCxTQUFTLE1BQU0sQ0FBQyxLQUFlO0lBQzdCLElBQUksTUFBTSxHQUFvQyxFQUFFLENBQUM7SUFDakQsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLEVBQUU7UUFDeEIsTUFBTSxHQUFHLEdBQUcsWUFBWSxDQUN0QixJQUFJLENBQUMsT0FBTyxDQUFDLDhCQUE4QixFQUFFLFFBQVEsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUM5RCxDQUFDO1FBQ0YsSUFBSSxLQUFLLEdBQW9CLElBQUk7YUFDOUIsT0FBTyxDQUFDLDhCQUE4QixFQUFFLFFBQVEsQ0FBQzthQUNqRCxJQUFJLEVBQUU7YUFDTixPQUFPLENBQUMsZ0JBQWdCLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFDdkMsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUM7WUFBRSxLQUFLLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ2pELE1BQU0sQ0FBQyxHQUFHLENBQUMsR0FBRyxLQUFLLENBQUM7S0FDckI7SUFDRCxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDO0FBRUQsNkRBQTZEO0FBQzdELFNBQVMsU0FBUyxDQUFDLElBQVk7SUFDN0IsSUFBSSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFDbkQsTUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUNyQyxJQUFJLE1BQU0sR0FBb0MsRUFBRSxDQUFDO0lBQ2pELEtBQUssTUFBTSxJQUFJLElBQUksS0FBSyxFQUFFO1FBQ3hCLE1BQU0sVUFBVSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDckMsTUFBTSxHQUFHLEdBQUcsWUFBWSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxFQUFFLFVBQVUsQ0FBQyxDQUFDLENBQUM7UUFDeEQsSUFBSSxLQUFLLEdBQW9CLElBQUk7YUFDOUIsU0FBUyxDQUFDLFVBQVUsR0FBRyxDQUFDLENBQUM7YUFDekIsSUFBSSxFQUFFO2FBQ04sT0FBTyxDQUFDLGdCQUFnQixFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBQ3ZDLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQUUsS0FBSyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNqRCxJQUFJLENBQUMsR0FBRztZQUFFLFNBQVM7UUFDbkIsTUFBTSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEtBQUssQ0FBQztLQUNyQjtBQUNILENBQUM7QUFRRCxTQUFTLGNBQWMsQ0FBQyxLQUFhLEVBQUUsUUFBZ0I7SUFDckQsTUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUMvQixJQUFJLE1BQU0sR0FBYTtRQUNyQixJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQztRQUNkLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDO1FBQ2QsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQztLQUNqQyxDQUFDO0lBQ0YsSUFBSSxNQUFNLENBQUMsSUFBSSxLQUFLLFlBQVksRUFBRTtRQUNoQyxJQUFJLElBQUksR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDNUIsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQzlCLE1BQU0sTUFBTSxHQUFHLEVBQUUsQ0FBQztRQUNsQixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsUUFBUSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQ2pDLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDbEIsSUFBSSxJQUFJLElBQUksQ0FBQztTQUNkO1FBQ0QsTUFBTSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7S0FDeEI7SUFDRCxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDO0FBRUQsU0FBUyxZQUFZLENBQUMsR0FBVztJQUMvQixNQUFNLE9BQU8sR0FBRztRQUNkLEVBQUUsRUFBRSxzQkFBc0I7UUFDMUIsZUFBZSxFQUFFLGlCQUFpQjtRQUNsQyxRQUFRLEVBQUUsVUFBVTtRQUNwQixFQUFFLEVBQUUsdUJBQXVCO1FBQzNCLFFBQVEsRUFBRSxVQUFVO1FBQ3BCLFdBQVcsRUFBRSxpQkFBaUI7UUFDOUIsS0FBSyxFQUFFLG1CQUFtQjtRQUMxQixhQUFhLEVBQUUsU0FBUztRQUN4QixJQUFJLEVBQUUsb0JBQW9CO1FBQzFCLElBQUksRUFBRSxZQUFZO1FBQ2xCLEVBQUUsRUFBRSxnQkFBZ0I7UUFDcEIsRUFBRSxFQUFFLFNBQVM7S0FDZCxDQUFDO0lBQ0YsSUFBSSxHQUFHLElBQUksT0FBTztRQUFFLE9BQU8sT0FBTyxDQUFDLEdBQTJCLENBQUMsQ0FBQztJQUNoRSxPQUFPLEdBQUcsQ0FBQztBQUNiLENBQUMifQ==